import React from "react";
import { useState } from "react";
import { Container, Row, Col, Card, Form, Button, Image } from 'react-bootstrap';

const logo = require('./../../assets/images/logo-badge.png');

export default function ResetPassword() {
   const [passType, setPassType] = useState(true);
   const [cpassType, setCpassType] = useState(true);

   return (
      <Container>
         <Row className="section mobile-bg align-items-center justify-content-center py-3">
            <Col sm={12} className="py-3">
               <Card className="card-login px-3">
                  <Card.Body>
                     <div className="auth-logo">
                        <Image src={logo}/>
                     </div>
                     <h3 className="fw-bold text-center mt-5 mb-3">Buat Kata Sandi Baru</h3>
                     <div className="text-secondary text-center mb-4">
                        Kata sandi baru kamu harus berbeda dari password sebelumnya
                     </div>
                     <Form>
                        <Form.Group className="mb-3" controlId="formBasicPassword">
                           <Form.Label className="mb-2">Kata Sandi</Form.Label>
                           <div className="position-relative">
                              <Form.Control type={passType ? 'password' : 'text'} placeholder="Kata sandi" />
                              <Form.Text className="input-icon" onClick={()=>setPassType(!passType)}>
                                 {passType ?
                                    <i className="ph-eye text-success-bold fw-bold"></i> :
                                    <i className="ph-eye-slash text-success-bold fw-bold"></i>
                                 }
                              </Form.Text>
                           </div>
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="formBasicPasswordConfirm">
                           <Form.Label className="mb-2">Konfirmasi Kata Sandi</Form.Label>
                           <div className="position-relative">
                              <Form.Control type={cpassType ? 'password' : 'text'} placeholder="Konfirmasi kata sandi" />
                              <Form.Text className="input-icon" onClick={()=>setCpassType(!cpassType)}>
                                 {cpassType ?
                                    <i className="ph-eye text-success-bold fw-bold"></i> :
                                    <i className="ph-eye-slash text-success-bold fw-bold"></i>
                                 }
                              </Form.Text>
                           </div>
                        </Form.Group>
                        <div className="d-grid gap-2 mt-4">
                           <Button className="btn-auth rounded-pill p-3" variant="success" type="submit">
                              BUAT KATA SANDI
                           </Button>
                        </div>
                     </Form>
                  </Card.Body>
               </Card>
            </Col>
         </Row>
      </Container>
   );
}